import { FC, SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement> & {
    className?: string
}

// Manual mode icon - chat bubbles
export const ManualChatIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <g clipPath="url(#clip0_manual_chat)">
            <path
                d="M13.3333 6.00065C12.8033 3.34398 10.342 1.33398 7.38666 1.33398C4.04266 1.33398 1.33333 3.90398 1.33333 7.07398C1.33333 8.59732 1.95866 9.98065 2.97933 11.0073C3.20333 11.234 3.35333 11.5427 3.29266 11.8607C3.1941 12.3778 2.96818 12.8621 2.63533 13.27C3.50763 13.428 4.40774 13.2893 5.192 12.876C5.46666 12.7307 5.60466 12.6587 5.70133 12.644C5.76933 12.6333 5.858 12.6433 6 12.6673"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.33333 10.842C7.33333 12.7787 8.97533 14.3493 11 14.3493C11.2387 14.3493 11.4751 14.3275 11.7093 14.284C11.878 14.2527 11.962 14.2367 12.0207 14.2453C12.0793 14.2547 12.1627 14.2987 12.3293 14.3873C12.8 14.638 13.3493 14.7267 13.878 14.628C13.6757 14.3787 13.5387 14.0829 13.4793 13.7673C13.4427 13.5727 13.5333 13.384 13.67 13.246C14.3066 12.6077 14.6649 11.7435 14.6667 10.842C14.6667 8.90465 13.0247 7.33398 11 7.33398C8.97533 7.33398 7.33333 8.90465 7.33333 10.842Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_manual_chat">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

// Map pin icon
export const MapIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <g clipPath="url(#clip0_map)">
            <path
                d="M16.0767 3.61252C17.0867 5.78585 17.0533 8.73085 15.935 10.81C15.0175 12.5158 13.6483 13.9267 12.52 15.4883C12.0042 16.2033 11.4833 16.9467 11.1292 17.7608C11.0117 18.0317 10.91 18.3092 10.81 18.5875C10.7092 18.865 10.6233 19.1483 10.5267 19.4275C10.4358 19.6892 10.33 19.9975 10.0042 20H9.99833C9.61 19.9992 9.51583 19.5583 9.41917 19.2608C9.1825 18.5325 8.935 17.8333 8.57 17.1567C8.145 16.37 7.36583 15.3183 6.82833 14.6067L16.0767 3.61252ZM7.12333 6.39263L3.64333 9.93585C4.24667 11.2192 5.33917 12.7292 6.21417 13.8267C6.42028 14.085 6.625 14.345 6.82833 14.6067L10.9817 9.66918L10.9575 9.67752C9.50667 10.1783 7.88167 9.43502 7.2975 8.02168C7.21774 7.82978 7.15933 7.62969 7.12333 7.42502C7.07083 7.06085 7.09524 6.72347 7.15607 6.3593L7.12333 6.39263ZM4.57667 2.62418L4.57417 2.62752C2.95167 4.68252 2.67333 7.52752 3.64333 9.93585L8.00004 5.5L7.5825 5.15335L4.57667 2.62418ZM12.2175 0.363349L9.01917 4.16585L9.04167 4.15752C10.375 3.69835 11.8775 4.28252 12.5583 5.51252C12.705 5.77835 12.8275 6.08168 12.8725 6.38335C12.9292 6.75502 12.9433 7.02752 12.8825 7.40002L12.88 7.41335L16.0767 3.61252C15.2414 2.08879 13.8681 0.931182 12.225 0.365849L12.2175 0.363349ZM8.00004 5.5L12.2175 0.363349L11.7625 0.227516C11.1835 0.0752113 10.5871 -0.00126134 9.98833 1.57334e-05C9.01884 0.00914651 8.06171 0.21862 7.17704 0.615283C6.29236 1.01195 5.49925 1.58723 4.8475 2.30502L4.57667 2.62418L8.00004 5.5Z"
                fill="currentColor"
            />
            <circle cx="10" cy="7" r="3" fill="white" />
        </g>
        <defs>
            <clipPath id="clip0_map">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

// Suspicious/warning icon - alert triangle
export const SuspiciousIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M9.99334 13.3337H10.0008M10 10.8337V7.50034M4.43501 8.0695C6.44584 4.51034 7.45168 2.73117 8.83168 2.27284C9.59021 2.02103 10.4098 2.02103 11.1683 2.27284C12.5483 2.73117 13.5542 4.51034 15.565 8.0695C17.5767 11.6278 18.5817 13.4078 18.2808 14.8578C18.1142 15.6562 17.7058 16.3795 17.1125 16.9245C16.0342 17.917 14.0225 17.917 10 17.917C5.97751 17.917 3.96584 17.917 2.88751 16.9253C2.29188 16.3753 1.88334 15.6526 1.71918 14.8587C1.41751 13.4087 2.42334 11.6287 4.43501 8.0695Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

// Accepted/checkmark icon
export const AcceptedIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path d="M13.3334 4L6.00002 11.3333L2.66669 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

// Pin icon (for pinning loads)
export const PinIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M2.5 17.5L6.66667 13.3334M11.0492 15.7259C7.92917 15.0175 4.9825 12.0709 4.27417 8.95087C4.16167 8.45754 4.10583 8.21087 4.26833 7.81004C4.43 7.41004 4.62917 7.28504 5.02583 7.03754C5.9225 6.47754 6.89417 6.29921 7.90167 6.38754C9.31583 6.51337 10.0233 6.57587 10.3767 6.39171C10.7292 6.20837 10.9683 5.77837 11.4483 4.91921L12.055 3.83004C12.455 3.11337 12.655 2.75421 13.1258 2.58504C13.5967 2.41587 13.88 2.51837 14.4467 2.72337C15.0979 2.95722 15.6893 3.33221 16.1786 3.82147C16.6678 4.31074 17.0428 4.90216 17.2767 5.55337C17.4817 6.12004 17.5842 6.40337 17.415 6.87421C17.2458 7.34421 16.8875 7.54421 16.17 7.94504L15.0558 8.56587C14.1975 9.04421 13.7692 9.28421 13.585 9.64004C13.4017 9.99671 13.4683 10.6884 13.6017 12.0717C13.7 13.0884 13.5308 14.0667 12.9633 14.975C12.715 15.3717 12.5908 15.57 12.19 15.7325C11.79 15.8942 11.5433 15.8384 11.0492 15.7259Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

// Telegram icon with paper plane logo
export const TelegramIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M10 0.0263672C12.6446 0.0263672 15.1832 1.07753 17.0518 2.94727C18.9219 4.81707 19.9736 7.35582 19.9736 10C19.9736 12.6442 18.9219 15.1829 17.0518 17.0527C15.1832 18.9225 12.6446 19.9736 10 19.9736C7.35539 19.9736 4.81678 18.9225 2.94824 17.0527C1.07813 15.1829 0.0263672 12.6442 0.0263672 10C0.0269038 7.35469 1.07777 4.81782 2.94824 2.94727C4.81678 1.07753 7.35539 0.0263672 10 0.0263672Z"
            fill="url(#paint0_telegram)"
            stroke="#0029D7"
            strokeWidth="0.0520833"
        />
        <path
            d="M4.52658 9.89404C7.4422 8.62404 9.38595 7.78675 10.3578 7.38217C13.136 6.22701 13.7125 6.02639 14.0891 6.01959C14.1719 6.01826 14.3563 6.03873 14.4766 6.136C14.5766 6.21803 14.6047 6.32897 14.6188 6.40686C14.6313 6.48467 14.6485 6.66201 14.6344 6.80045C14.4844 8.3817 13.8328 12.2189 13.5016 13.99C13.3625 14.7394 13.086 14.9906 12.8188 15.0151C12.2375 15.0686 11.7969 14.6314 11.2344 14.2628C10.3547 13.6858 9.85783 13.3267 9.00314 12.7637C8.01564 12.1131 8.65626 11.7554 9.21876 11.1711C9.36564 11.0181 11.925 8.69076 11.9735 8.47967C11.9797 8.45326 11.986 8.35482 11.9266 8.30295C11.8688 8.25092 11.7828 8.26873 11.7203 8.28279C11.6313 8.30279 10.2266 9.23217 7.50158 11.0708C7.10314 11.3448 6.7422 11.4784 6.4172 11.4714C6.06095 11.4637 5.37345 11.2695 4.86251 11.1036C4.23751 10.9 3.73908 10.7923 3.78283 10.4465C3.8047 10.2665 4.05314 10.0823 4.52658 9.89404Z"
            fill="white"
        />
        <defs>
            <linearGradient id="paint0_telegram" x1="1000" y1="0" x2="1000" y2="2000" gradientUnits="userSpaceOnUse">
                <stop stopColor="#2AABEE" />
                <stop offset="1" stopColor="#229ED9" />
            </linearGradient>
        </defs>
    </svg>
)

// Email icon
export const EmailIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M5.83337 7.08398L8.28504 8.53398C9.71421 9.37898 10.285 9.37898 11.715 8.53398L14.1667 7.08398"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.68001 11.231C1.73417 13.7851 1.76167 15.0626 2.70417 16.0085C3.64667 16.9551 4.95834 16.9876 7.58251 17.0535C9.19917 17.0951 10.8008 17.0951 12.4175 17.0535C15.0417 16.9876 16.3533 16.9551 17.2958 16.0085C18.2383 15.0626 18.2658 13.7851 18.3208 11.231C18.3375 10.4093 18.3375 9.59263 18.3208 8.77097C18.2658 6.2168 18.2383 4.9393 17.2958 3.99347C16.3533 3.0468 15.0417 3.0143 12.4175 2.94847C10.8061 2.9078 9.19392 2.9078 7.58251 2.94847C4.95834 3.0143 3.64667 3.0468 2.70417 3.99347C1.76167 4.9393 1.73417 6.2168 1.67917 8.77097C1.66163 9.59087 1.66246 10.4111 1.68001 11.231Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

// Collapse/expand icon - chevron down
export const CollapseIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M15 7.5C15 7.5 11.3175 12.5 10 12.5C8.6825 12.5 5 7.5 5 7.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

// Send icon - paper plane
export const SendIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M8.74928 11.2501L17.4993 2.50014M8.85559 11.5235L11.0457 17.1552C11.2386 17.6513 11.3351 17.8994 11.4741 17.9718C11.5946 18.0346 11.7381 18.0347 11.8587 17.9721C11.9978 17.8998 12.0946 17.6518 12.2881 17.1559L17.78 3.08281C17.9547 2.6336 18.0421 2.409 17.9943 2.26636C17.9528 2.14193 17.8576 2.04671 17.7331 2.00523C17.5905 1.95736 17.3659 2.0447 16.9167 2.21939L2.84358 7.71134C2.34771 7.90486 2.09978 8.00163 2.02756 8.14071C1.9646 8.26129 1.96469 8.40483 2.02756 8.52533C2.09993 8.66433 2.34808 8.7608 2.84437 8.95373L8.47609 11.1438C8.57524 11.1826 8.62482 11.2021 8.66793 11.2314C8.70635 11.2573 8.74017 11.2912 8.76605 11.3296C8.79532 11.3727 8.81486 11.4223 8.85393 11.5214L8.85559 11.5235Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

// AI Email Icon
export const AIEmailIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M5.83331 7.08398L8.28498 8.53398C9.71415 9.37898 10.285 9.37898 11.715 8.53398L14.1666 7.08398"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.68001 11.231C1.73417 13.7851 1.76167 15.0626 2.70417 16.0085C3.64667 16.9551 4.95834 16.9876 7.58251 17.0535C9.19917 17.0951 10.8008 17.0951 12.4175 17.0535C15.0417 16.9876 16.3533 16.9551 17.2958 16.0085C18.2383 15.0626 18.2658 13.7851 18.3208 11.231C18.3375 10.4093 18.3375 9.59263 18.3208 8.77097C18.2658 6.2168 18.2383 4.9393 17.2958 3.99347C16.3533 3.0468 15.0417 3.0143 12.4175 2.94847C10.8061 2.9078 9.19392 2.9078 7.58251 2.94847C4.95834 3.0143 3.64667 3.0468 2.70417 3.99347C1.76167 4.9393 1.73417 6.2168 1.67917 8.77097C1.66163 9.59087 1.66246 10.4111 1.68001 11.231Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

// Phone/Call icon
export const PhoneIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M6.1057 3.808L5.83704 3.204C5.6617 2.80933 5.5737 2.612 5.44237 2.46067C5.27807 2.27114 5.06363 2.13181 4.8237 2.05867C4.63237 2 4.41637 2 3.9837 2C3.3517 2 3.0357 2 2.77037 2.12133C2.44305 2.28036 2.18969 2.55951 2.06304 2.90067C1.9677 3.176 1.99504 3.45933 2.0497 4.02667C2.63193 10.06 5.93993 13.3678 11.9737 13.95C12.5404 14.0047 12.8237 14.032 13.0997 13.9367C13.4405 13.81 13.7194 13.5569 13.8784 13.23C13.9997 12.964 13.9997 12.648 13.9997 12.016C13.9997 11.5833 13.9997 11.3673 13.941 11.176C13.8679 10.9361 13.7286 10.7216 13.539 10.5573C13.3884 10.426 13.1904 10.3387 12.7957 10.1627L12.1917 9.89467C11.7637 9.70467 11.5504 9.60933 11.333 9.58867C11.1249 9.56869 10.9151 9.59792 10.7204 9.674C10.517 9.75333 10.3377 9.90267 9.9777 10.2027C9.6197 10.5007 9.44104 10.6493 9.22237 10.7293C9.01248 10.8019 8.78865 10.825 8.56837 10.7967C8.3377 10.7633 8.1617 10.6687 7.80837 10.48C6.7117 9.89333 6.10637 9.28867 5.5197 8.19133C5.33104 7.838 5.23704 7.662 5.20304 7.43133C5.17464 7.21133 5.19746 6.98774 5.2697 6.778C5.3497 6.55867 5.49904 6.38 5.79704 6.022C6.09704 5.662 6.24704 5.48267 6.3257 5.27933C6.4017 5.08467 6.43104 4.87467 6.41104 4.66667C6.39104 4.45 6.2957 4.236 6.10504 3.808H6.1057Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
)

// AI Call icon - phone with AI indicator
export const AICallIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <g clipPath="url(#clip0_ai_call)">
            <path
                d="M5.43969 4.47499L5.17102 3.87099C4.99569 3.47633 4.90769 3.27899 4.77636 3.12766C4.61205 2.93813 4.39762 2.7988 4.15769 2.72566C3.96636 2.66699 3.75036 2.66699 3.31769 2.66699C2.68569 2.66699 2.36969 2.66699 2.10436 2.78833C1.77704 2.94735 1.52368 3.22651 1.39702 3.56766C1.30169 3.84299 1.32902 4.12633 1.38369 4.69366C1.96591 10.727 5.27391 14.0348 11.3077 14.617C11.8744 14.6717 12.1577 14.699 12.4337 14.6037C12.7745 14.477 13.0533 14.2239 13.2124 13.897C13.3337 13.631 13.3337 13.315 13.3337 12.683C13.3337 12.2503 13.3337 12.0343 13.275 11.843C13.2019 11.6031 13.0625 11.3886 12.873 11.2243C12.7224 11.093 12.5244 11.0057 12.1297 10.8297L11.5257 10.5617C11.0977 10.3717 10.8844 10.2763 10.667 10.2557C10.4589 10.2357 10.2491 10.2649 10.0544 10.341C9.85102 10.4203 9.67169 10.5697 9.31169 10.8697C8.95369 11.1677 8.77502 11.3163 8.55635 11.3963C8.34646 11.4689 8.12263 11.4919 7.90235 11.4637C7.67169 11.4303 7.49569 11.3357 7.14236 11.147C6.04569 10.5603 5.44036 9.95566 4.85369 8.85832C4.66502 8.50499 4.57102 8.32899 4.53702 8.09833C4.50862 7.87832 4.53144 7.65473 4.60369 7.44499C4.68369 7.22566 4.83302 7.04699 5.13102 6.68899C5.43102 6.32899 5.58102 6.14966 5.65969 5.94633C5.73569 5.75166 5.76502 5.54166 5.74502 5.33366C5.72502 5.11699 5.62969 4.90299 5.43902 4.47499H5.43969Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
            <path
                d="M8.66699 5.91699L10.0485 1.77249C10.0832 1.66906 10.1495 1.57914 10.238 1.51544C10.3266 1.45173 10.4329 1.41745 10.542 1.41745C10.6511 1.41745 10.7574 1.45173 10.846 1.51544C10.9345 1.57914 11.0008 1.66906 11.0355 1.77249L12.417 5.91699M14.667 1.41699V5.91699M9.41699 4.41699H11.667"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_ai_call">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

// Private Loads icon (box/package icon representing private/exclusive loads)
export const PrivateLoadsIcon: FC<IconProps> = ({ className, ...props }) => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M2.5 6.66699L10 2.08366L17.5 6.66699V13.3337L10 17.917L2.5 13.3337V6.66699Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10 10V17.917" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.5 6.66699L10 10.0003L2.5 6.66699" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.25 4.375L13.75 8.125" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
